import { Component, OnInit } from '@angular/core';
import { FormFieldAbstractComponent } from '../abstract.component';
import { Observable, of } from 'rxjs';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { FormFieldsService } from '@shared/shared';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'crm-form-field-checkbox-slider',
  templateUrl: './checkbox-slider.component.html',
  styleUrls: ['./checkbox-slider.component.scss'],
})
export class FormFieldCheckboxSliderComponent extends FormFieldAbstractComponent implements OnInit {
  get readonlyValue$(): Observable<any> {
    const value = this.formFieldsService.serializeValues(this.parentFormGroup, [this.field])[this.field.key];
    return of(
      value == null
        ? ''
        : value
        ? this.translocoService.translate('formFieldCheckbox.yes')
        : this.translocoService.translate('formFieldCheckbox.no'),
    );
  }

  constructor(protected formFieldsService: FormFieldsService, private translocoService: TranslocoService) {
    super(formFieldsService);
    registerTranslationsManually(
      'formFieldCheckboxSlider',
      translocoService,
      import.meta.webpackContext!('./translation'),
    );
  }
}
